import {
  Facet,
  FacetsAdapterResult,
} from '../../../collaborators/fetch-products/new-contract/types';
import config, { defaultConfig } from '../../config';
import getMaxSelectionOptions from '../../price-facet-adapter/collaborators/get-max-selection-options';
import getMinSelectionOptions from '../../price-facet-adapter/collaborators/get-min-selection-options';
import calculatePriceIncrement from '../../price-facet-adapter/collaborators/calculate-price-increment';

const getMinOptions = (facet: Facet, increment: number) => {
  return getMinSelectionOptions(facet.appliedRange, facet.range, increment);
};

const getMaxOptions = (facet: Facet, increment: number) => {
  return getMaxSelectionOptions(facet.appliedRange, facet.range, increment);
};

const getRangeProperties = (
  facet: Facet,
  rangeMinMax: Record<string, string>
) =>
  facet.range && {
    ...{ range: facet.appliedRange || rangeMinMax },
  };

const getRangeFacetName = (facet: Facet) => ({ ...(config[facet.name] ?? {}) });

const getAppliedValues = (shouldShow: boolean, priceFacet: Facet) => {
  return shouldShow ? [priceFacet] : [];
};

const shouldShowAppliedValues = (
  rangeMinMax: { min: number; max: number },
  increment: number,
  facet: Facet
) => {
  const differenceGreaterOrEqualThanIncrement =
    rangeMinMax.max - rangeMinMax.min >= increment;
  const shouldShow =
    differenceGreaterOrEqualThanIncrement && facet.appliedRange;
  return shouldShow;
};

export default (facets: Facet[]): FacetsAdapterResult => {
  const facetOptions = facets
    .filter((facet: Facet) => facet.type === 'range')
    .map((facet: Facet) => {
      const increment = calculatePriceIncrement(
        facet.range?.min,
        facet.range?.max
      );
      const minOptions = getMinOptions(facet, increment);
      const maxOptions = getMaxOptions(facet, increment);
      const rangeMinMax = { min: minOptions[0], max: maxOptions[0] };
      const shouldShow = shouldShowAppliedValues(rangeMinMax, increment, facet);

      const priceFacet = {
        ...defaultConfig,
        appliedRange: facet.appliedRange,
        name: facet.name,
        type: facet.type,
        localizedName: facet.localeName,
        displayName: facet.localeName,
        isActive: facet.isActive,
        ...(minOptions && { minOptions }),
        ...(maxOptions && { maxOptions }),
        ...getRangeFacetName(facet),
        ...getRangeProperties(facet, rangeMinMax),
      };

      return {
        ...priceFacet,
        appliedValues: getAppliedValues(shouldShow, priceFacet),
      };
    });

  const hasTags = facetOptions?.some((x) => x.appliedRange);

  return { hasTags, facetOptions };
};
